exports = module.exports = require("../../../../../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, "/* ANIMATION */\n/* SHADOWS */\n.DesktopNotifications__title__2THau h4 {\n  font-weight: 400;\n  font-size: 16px;\n  width: 100%;\n  margin: 20px 0 0 0;\n  color: #0070DD; }\n\n.DesktopNotifications__title__2THau:hover {\n  text-decoration: none; }\n", ""]);

// exports
exports.locals = {
	"title": "DesktopNotifications__title__2THau"
};